module.exports = __webpack_public_path__ + "static/media/3DPPA27.acb612d3.jpg";